import {
  CompanyContainer,
  CompanyContentContainer,
  CompanyTabsContent,
  CompanyTabsList,
} from "components/company/v3/CompanyContainers";
import useBrazilianIssuer from "components/company/v3/context/hooks/useBrazilianIssuer";
import { CompanyDiscussionsTabEnum } from "components/company/v3/menu/enums";
import AssetDiscussion from "components/discussions/AssetDiscussion";
import { Tabs } from "components/ui/tabs/v2/TabsV2";
import { MessageCircleIcon } from "lucide-react";
import { useIntl } from "react-intl";
import { IAssetType } from "types/graphqlTypes";

interface BrazilianDiscussionsBoxProps {
  tab: CompanyDiscussionsTabEnum;
  onChangeTab: (tab: CompanyDiscussionsTabEnum) => void;
}

export default function BrazilianDiscussionsBox({ tab, onChangeTab }: BrazilianDiscussionsBoxProps) {
  const issuer = useBrazilianIssuer();
  const intl = useIntl();

  return (
    <CompanyContainer className="items-center xl:h-full">
      <CompanyContentContainer className="h-full w-full space-y-4 border-none lg:min-h-[416px] xl:min-h-96 2xl:min-h-[472px]">
        <Tabs
          defaultValue={CompanyDiscussionsTabEnum.COMMENTS}
          value={tab}
          onValueChange={(value) => onChangeTab(value as CompanyDiscussionsTabEnum)}
          className="w-full"
        >
          <CompanyTabsList
            activeTab={tab}
            tabs={[
              {
                value: CompanyDiscussionsTabEnum.COMMENTS,
                label: intl.formatMessage({
                  defaultMessage: "Discussões",
                  description: "Aba do menu superior da empresa",
                  id: "d0ZYTR",
                }),
                icon: <MessageCircleIcon className="inline-flex" size={16} strokeWidth={2} />,
              },
            ]}
          />

          <CompanyTabsContent
            value={CompanyDiscussionsTabEnum.COMMENTS}
            className="min-h-96 p-0 lg:min-h-[521px] xl:min-h-[344px] 2xl:min-h-[344px]"
          >
            <AssetDiscussion hideHeaderLine={true} assetType={IAssetType.BrazilianCompany} assetId={issuer._id} />
          </CompanyTabsContent>
        </Tabs>
      </CompanyContentContainer>
    </CompanyContainer>
  );
}
